import React from "react";

// Shown while a page that loads on demand (see routeConfig.js) downloads,
// in the same style as the workspace loading screen.
const RouteLoading = () => (
  <section className="workspace-transition route-loading" role="status" aria-live="polite">
    <div className="workspace-transition__spinner" aria-hidden="true" />
    <p>Loading…</p>
  </section>
);

export default RouteLoading;
